export default __webpack_public_path__ + "./image/2f393cb30d0dab981b97f680f75346c2.png";